import Loader from 'components/Loader'
import LocationModal from '../LocationModal'
import React, { useState } from 'react'

interface LocationProps {
  gps?: base.Coords
  isSending: boolean
  handleNextStep: () => void
  setGps: (gps: base.Coords | undefined) => void
}

const Location: React.FC<LocationProps> = ({ gps, isSending, setGps, handleNextStep }) => {
  const [modal, setModal] = useState<boolean>(false)

  if (isSending) {
    return <Loader type='full' />
  }
  
  return (
    <>
      {modal && <LocationModal onClose={() => setModal(false)} coords={gps} updatePosition={setGps} nextStep={handleNextStep} />}
      <div className='addProfile__location'>
        <div className="addProfile__location__content">
          <div className="infoLabel">
            <p>Jeżeli nie jesteś teraz przy pomniku, możesz dodać lokalizację później</p>
          </div>
          <div className="location" onClick={() => setModal(true)}>
            <i className="icon icon--location"></i>
            <h1>Dodaj lokalizację pomnika</h1>
          </div>
        </div>
        <div className="addProfile__location__footer">
          <button className={`btn btn--secondary `} onClick={handleNextStep}>Pomiń</button>
          <button className={`btn btn--primary `} onClick={() => setModal(true)}>Dodaj Lokalizację</button>
        </div>
      </div>
    </>)
}

export default Location